import React, { memo } from "react";
import { Box } from "@pochta/ui";
import { ErrorPageAppStore, ErrorPageGooglePlay } from "../ErrorPage.styles";

var ErrorPageApps = function ErrorPageApps(_ref) {
  var mobileCentered = _ref.mobileCentered,
      isMobile = _ref.isMobile,
      isMobSafari = _ref.isMobSafari,
      appStore = _ref.appStore,
      googlePlay = _ref.googlePlay;
  return /*#__PURE__*/React.createElement(Box, {
    pt: "21px",
    pb: "27px",
    textAlign: mobileCentered && isMobile ? "center" : "left"
  }, isMobile && isMobSafari && /*#__PURE__*/React.createElement(ErrorPageAppStore, {
    href: appStore
  }), isMobile && !isMobSafari && /*#__PURE__*/React.createElement(ErrorPageGooglePlay, {
    href: googlePlay
  }), !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ErrorPageAppStore, {
    href: appStore
  }), /*#__PURE__*/React.createElement(ErrorPageGooglePlay, {
    href: googlePlay
  })));
};

export default /*#__PURE__*/memo(ErrorPageApps);